import classes from "../subPagesClasses.module.scss";
import { CustomerInsightOutletContext } from "../..";
import { useOutletContext } from "react-router-dom";
import { useEffect, useState } from "react";
import MessageBox from "components/elements/MessageBox";
import I18n from "components/materials/I18n";
import { getInputListSubFinanceDurable } from "components/pages/Subscriptions/corporation/SubscriptionQuestionsCorporation/SubFinanceDurableCorporation";
import { EFinanceDurableCorporationGroups } from "common/enums/Scpi/Corporation/Groups/EFinanceDurableCorporationGroups";

export default function CustomerInsightFinanceDurable() {
	const { subscription, renderInputList } = useOutletContext<CustomerInsightOutletContext>();

	const [inputList, setInputList] = useState<Record<EFinanceDurableCorporationGroups, JSX.Element | null> | null>(null);

	useEffect(() => {
		if (!subscription) return;
		setInputList(getInputListSubFinanceDurable(subscription, true, true));
	}, [subscription]);

	if (!inputList || !subscription) return null;

	return (
		<div className={classes["root"]}>
			{!subscription.financeDurable && (
				<MessageBox className={classes["warning-prelevement"]} type="info" text={I18n.asset.pages.client.sub_pages.customer_insight.no_data} />
			)}
			{subscription.financeDurable && renderInputList(inputList)}
		</div>
	);
}
